<template>
    <div class="flex flex-col items-center bg-white max-w-3xl mx-auto">

        <CreditStrongLogo class="mb-8"/>

        <h3 class="text-xl font-semibold text-center text-green-500 mb-4 leading-6">
            Build your credit with CreditStrong, opening the door to better loans
        </h3>
        
        <h4 class="text-xl font-bold text-center text-gray-800 mb-6 leading-6">
            Check out our partner offer that can build your score an average of 86 points!
        </h4>

        <p class="text-gray-700 text-center mb-4">
            MAGNUM by CreditStrong is the largest credit builder in the nation, building your score an average* of 86
            points and can help qualify you for larger loan amounts, along with better rates and terms.
        </p>

        <h4 class="text-lg font-semibold text-gray-800 mt-6 mb-2">What do you get with MAGNUM?</h4>

        <ul class="list-disc list-inside text-gray-700 mb-4">
            <li>Up to $30k credit builder installment loan on your personal credit profile</li>
            <li>Reported to all 3 major credit bureaus: Experian, TransUnion, Equifax</li>
            <li>Free monthly FICO&reg; Score 8 to track your progress - the most commonly used credit score by lenders</li>
        </ul>
    </div>
</template>

<script>
import CreditStrongLogo from '../../../components/CreditStrongLogo.vue';
export default {
    components: {
        CreditStrongLogo
    }
};
</script>
